const pageNameKey = "alarmNodeDetailsPanel";

export const alarmNodeDetailsPanelEn = {
  [pageNameKey]: {
    variableIconAlt: "Variable",
    timeseriesLabel: "Timeseries",
    connectedTo: "Connected to",
    disclaimer:
      "Info: Please be aware that the tabs 'Last day', 'Last week' and 'Last month' use average aggregated data with a 15 minutes detection frequency.",
    last8Hours: "Last 8 hours",
    lastDay: "Last day",
    lastWeek: "Last week",
    lastMonth: "Last month",
  },
};

export const alarmNodeDetailsPanelPtBr = {
  [pageNameKey]: {
    variableIconAlt: "Variável",
    timeseriesLabel: "Série temporal",
    connectedTo: "Conectado a",
    disclaimer:
      "Informação: Esteja ciente de que as abas 'Last day', 'Last week' e 'Last month' usam dados agregados médios com uma frequência de detecção de 15 minutos.",
    last8Hours: "Últimas 8 horas",
    lastDay: "Último dia",
    lastWeek: "Semana passada",
    lastMonth: "Mês passado",
  },
};

export const alarmNodeDetailsPanelDe = {
  [pageNameKey]: {
    variableIconAlt: "Variable",
    timeseriesLabel: "Timeseries",
    connectedTo: "Verbunden mit",
    disclaimer:
      "Info: Bitte beachten Sie, dass die Registerkarten „Letzter Tag“, „Letzte Woche“ und „Letzter Monat“ durchschnittliche aggregierte Daten mit einer Erkennungsfrequenz von 15 Minuten verwenden.",
    last8Hours: "Letzte 8 Stunden",
    lastDay: "Letzter Tag",
    lastWeek: "Letzte Woche",
    lastMonth: "Letzter Monat",
  },
};

export const alarmNodeDetailsPanelZhHans = {
  [pageNameKey]: {
    variableIconAlt: "变量",
    timeseriesLabel: "时间序列",
    connectedTo: "连接到",
    disclaimer:
      "信息：请注意，标签“最近一天”、“最近一周”和“最近一个月”使用平均聚合数据，检测频率为15分钟。",
    last8Hours: "最近8小时",
    lastDay: "最近1天",
    lastWeek: "最近1周",
    lastMonth: "最近1个月",
  },
};

export const alarmNodeDetailsPanelIt = {
  [pageNameKey]: {
    variableIconAlt: "Variabile",
    timeseriesLabel: "Timeseries",
    connectedTo: "Connesso a",
    disclaimer:
      'Informazioni: tieni presente che le schede "Ultime 24 ore", "Ultima settimana" e "Ultimo mese" utilizzano dati medi aggregati con una frequenza di rilevamento di 15 minuti.',
    last8Hours: "Ultime 8 ore",
    lastDay: "Ultime 24 ore",
    lastWeek: "La settimana scorsa",
    lastMonth: "Il mese scorso",
  },
};

export const alarmNodeDetailsPanelEs = {
  [pageNameKey]: {
    variableIconAlt: "Variable",
    timeseriesLabel: "Serie temporal",
    connectedTo: "Conectado a",
    disclaimer:
      "Información: Ten en cuenta que las pestañas 'Último día', 'Última semana' y 'Último mes' utilizan datos agregados promedio con una frecuencia de detección de 15 minutos.",
    last8Hours: "Últimas 8 horas",
    lastDay: "Último día",
    lastWeek: "La semana pasada",
    lastMonth: "El mes pasado",
  },
};

export const alarmNodeDetailsPanelNl = {
  [pageNameKey]: {
    connectedTo: "Verbonden met",
    disclaimer:
      "Info: Houd er rekening mee dat de tabbladen 'Laatste dag', 'Laatste week' en 'Laatste maand' gemiddeld geaggregeerde gegevens gebruiken met een detectiefrequentie van 15 minuten.",
    timeseriesLabel: "Tijdreeks",
    variableIconAlt: "Variabele",
    last8Hours: "Laatste 8 uur",
    lastDay: "Laatste dag",
    lastWeek: "Laatste week",
    lastMonth: "Laatste maand",
  },
};

export const alarmNodeDetailsPanelTr = {
  [pageNameKey]: {
    connectedTo: "Şuraya bağlanıldı:",
    disclaimer:
      "Bilgi: 'Son gün', 'Geçen hafta' ve 'Geçen ay' sekmelerinin 15 dakikalık algılama sıklığıyla ortalama toplu verileri kullandığını lütfen unutmayın.",
    last8Hours: "Son 8 saat",
    lastDay: "Son gün",
    lastMonth: "Geçen ay",
    lastWeek: "Geçen hafta",
    timeseriesLabel: "Zaman Serisi",
    variableIconAlt: "Değişken",
  },
};
